import React from 'react';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup'; // import { Debug } from '../../Molecules/Forms/Debug';

import { Button, SubmitButton, Typography, Paper, makeStyles } from '../../';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '30px',
      flexDirection: 'column'
    },
    rootPaper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '30px'
    },
    title: {
      paddingTop: '8px'
    }
  };
});
var emailSchema = Yup.object().shape({
  email: Yup.string().email('Debes introducir un email válido').required('Campo obligatorio')
});
var resetPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Debes introducir un email válido').required('Campo obligatorio'),
  code: Yup.string(),
  password: Yup.string().required('Campo obligatorio').matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^_\-!?;.,:*[\]{}()@%&/"\\<>|'~`]).{8,}$/, 'Debe contener 8 caracteres, una mayúscula, minúscula, número y carácter especial'),
  passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Las contraseñas no coinciden')
});

var ResetPasswordContent = function ResetPasswordContent(props) {
  var classes = useStyles();
  var content, initialValues, schema, title;
  var emailInitialValues = {
    email: '',
    password: ''
  };
  var resetPasswordInitialValues = {
    email: props.email,
    code: '',
    password: '',
    passwordConfirmation: ''
  };

  var getContent = function getContent(isValid, isSubmitting) {
    switch (props.variant) {
      case 'RESET_PASSWORD':
        content = [/*#__PURE__*/React.createElement(Typography, {
          variant: "h6",
          align: "center"
        }, "Comprueba tu bandeja de entrada, te hemos enviado un c\xF3digo que deber\xE1s introducir para restablecer la contrase\xF1a"), /*#__PURE__*/React.createElement(Field, {
          name: "email",
          fullWidth: true,
          label: "Email",
          component: TextField,
          margin: "normal",
          variant: "outlined",
          autoComplete: "" //disabled={mode === 'view'}

        }), /*#__PURE__*/React.createElement(Field, {
          name: "code",
          fullWidth: true,
          label: "C\xF3digo",
          component: TextField,
          type: "text",
          margin: "normal",
          variant: "outlined" //disabled={mode === 'view'}

        }), /*#__PURE__*/React.createElement(Field, {
          name: "password",
          fullWidth: true,
          label: "Nueva contrase\xF1a",
          component: TextField,
          type: "password",
          margin: "normal",
          variant: "outlined" //disabled={mode === 'view'}

        }), /*#__PURE__*/React.createElement(Field, {
          name: "passwordConfirmation",
          fullWidth: true,
          label: "Repetir contrase\xF1a",
          component: TextField,
          type: "password",
          margin: "normal",
          variant: "outlined" //disabled={mode === 'view'}

        }), /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          color: "primary",
          variant: "contained",
          disabled: !isValid || isSubmitting,
          component: SubmitButton,
          type: "submit"
        }, "Resetear contrase\xF1a")];
        break;

      default:
        content = [/*#__PURE__*/React.createElement(Typography, {
          variant: "h6",
          align: "center"
        }, "Introduce tu correo y te enviaremos un c\xF3digo para restablecer tu contrase\xF1a"), /*#__PURE__*/React.createElement(Field, {
          name: "email",
          fullWidth: true,
          label: "Email",
          component: TextField,
          margin: "normal",
          variant: "outlined",
          autoComplete: "" //disabled={mode === 'view'}

        }), /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          color: "primary",
          variant: "contained",
          disabled: !isValid || isSubmitting,
          component: SubmitButton,
          type: "submit"
        }, "Enviar correo")];
        break;
    }

    return content;
  };

  switch (props.variant) {
    case 'RESET_PASSWORD':
      title = 'Restablecer contraseña';
      initialValues = resetPasswordInitialValues;
      schema = resetPasswordSchema;
      break;

    default:
      title = '¿Has olvidado la contraseña?';
      initialValues = emailInitialValues;
      schema = emailSchema;
      break;
  }

  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.rootPaper
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: schema,
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;
      resetForm({
        email: values.email,
        code: '',
        password: '',
        passwordConfirmation: ''
      });

      if (props.variant === 'RESET_PASSWORD') {
        props.resetPassword(values);
      } else {
        props.forgotPassword(values);
      }
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          setFieldValue = _ref2.setFieldValue,
          handleBlur = _ref2.handleBlur,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      return [/*#__PURE__*/React.createElement(Typography, {
        variant: "h4",
        align: "center"
      }, title), /*#__PURE__*/React.createElement(Form, {
        className: classes.form
      }, getContent(isValid, isSubmitting))];
    }
  }));
};

export { ResetPasswordContent };